import { Divider, Radio } from '@apollo/orbit';
import classnames from 'classnames';
import React from 'react';

import { Icon as IconBolt } from 'src/assets/icon-bolt.svg';
import {
  FastModeRange,
  RangeSelectedFn,
  TimeRangeOption,
  printTimeRangeLabel,
} from 'src/lib/config/timeRangeOptions';

type Props = {
  className?: string;
  onRangeSelected: RangeSelectedFn;
  range: TimeRangeOption;
  from: Date;
  to: Date;
  options: TimeRangeOption[];
  isDisabledProFeature: (range: string, isRangeRestricted: boolean) => boolean;
  handleChange: (
    to: Date,
    from: Date,
    range: TimeRangeOption,
    onRangeSelected: RangeSelectedFn,
    selectedFastModeRange?: FastModeRange,
  ) => void;
  maxRangeInDays: number;
  fastModeRange?: FastModeRange;
};

export const FastModeSection = ({
  range,
  fastModeRange,
  handleClick,
}: {
  range: TimeRangeOption;
  fastModeRange?: string;
  handleClick: (option: FastModeRange) => void;
}) => {
  const fastModeRanges: FastModeRange[] = ['lastMonth', 'lastThreeMonths'];
  return (
    <>
      <Divider className="py-1" />
      <div className="flex pt-2">
        <IconBolt className="text-link" />
        <p className="text-base font-semibold text-link">Fast Mode</p>
      </div>
      <p className="py-1 text-secondary">
        This view excludes the last 24 hours of data for faster load times.
      </p>
      {fastModeRanges.map((option) => {
        return (
          <div
            key={option}
            className={classnames(
              '-mx-2 flex items-center rounded px-2 py-1',
              'cursor-pointer hover:bg-primary',
            )}
            onClick={() => {
              handleClick(option);
            }}
          >
            <Radio isChecked={range === option && !!fastModeRange} />
            <span className="ml-2 flex-1">{printTimeRangeLabel(option)}</span>
          </div>
        );
      })}
    </>
  );
};

export const EnabledOptionsSection = ({
  className,
  range,
  from,
  to,
  options,
  isDisabledProFeature,
  handleChange,
  maxRangeInDays,
  onRangeSelected,
  fastModeRange,
}: Props) => {
  const isRangeRestricted = Boolean(maxRangeInDays) && maxRangeInDays === 1;

  return (
    <div className={className}>
      {options.map((option) => {
        const disabled = isDisabledProFeature(option, isRangeRestricted);

        return (
          <div key={option}>
            {!disabled && (
              <div
                key={option}
                className={classnames(
                  '-mx-2 flex items-center rounded px-2 py-1',
                  'cursor-pointer hover:bg-primary',
                )}
                onClick={() => {
                  handleChange(to, from, option, onRangeSelected);
                }}
              >
                <Radio isChecked={range === option && !fastModeRange} />
                <span className="ml-2 flex-1">
                  {printTimeRangeLabel(option)}
                </span>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};
